<template>
  <div id="content-wrapper">
    <b-form-group class="border-bottom-form">
      <div class="d-flex">
        <div class="flex-1-0">
          <b-form-input
            v-if="false"
            @keyup.enter="layDanhSachApp"
            id="filterBy"
            placeholder="Nhập từ khóa tìm kiếm"
            required
            type="text"
            v-model="requestInformation.filterBy"
          />
        </div>
        <div class="ml-1">
          <base-button
            button="Tìm kiếm"
            @click="layDanhSachApp()"
            v-if="false"
          />
          <base-button
            class="float-right"
            button="Thêm mới"
            v-if="hasPermissionUser(PERMISSION_NAME.UNG_DUNG.THEM)"
            @click="openCreate"
          />
        </div>
      </div>
    </b-form-group>
    <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
    <DataTable
      :value="items"
      :loading="isLoadingTable"
      dataKey="id"
      class="p-datatable-customers"
    >
      <Column
        field="id"
        dataKey="id"
        headerStyle="width: 40px"
        headerClass="p-2"
        header="STT"
        bodyStyle="text-align: center"
      >
        <template #filter> </template>
        <template #body="slotProps">
          <span>
            {{
              (requestInformation.pageIndex - 1) * requestInformation.pageSize +
              slotProps.index +
              1
            }}</span
          >
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="code"
        header="Mã ứng dụng"
        headerStyle="minWidth: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.Code"
            @change="layDanhSachApp"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.code }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="name"
        header="Tên ứng dụng"
        headerStyle="minWidth: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.Name"
            @change="layDanhSachApp"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.name }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="description"
        header="Mô tả"
        headerStyle="minWidth: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.Description"
            @change="layDanhSachApp"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.description }}</span>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="url"
        header="URL"
        headerStyle="minWidth: 200px"
      >
        <template #filter>
          <InputText
            type="text"
            class="p-column-filter"
            placeholder="Tìm kiếm"
            v-model="requestForm.URL"
            @change="layDanhSachApp"
          />
        </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.url }}</span>
        </template>
      </Column>

      <Column
        filterMatchMode="custom"
        field="isActive"
        v-if="false"
        header="Trạng thái"
        headerStyle="minWidth: 200px"
      >
        <template #body="slotProps">
          <b-form-checkbox
            class="text-center cursor-pointer"
            :checked="slotProps.data.isActive"
            switch
            v-model="slotProps.data.isActive"
            @change="handleChangeTrangThai(slotProps.data)"
          ></b-form-checkbox>
        </template>
      </Column>
      <Column
        filterMatchMode="custom"
        field="thaoTac"
        header="Thao tác"
        headerStyle="width: 150px"
        v-if="
          hasPermissionUser(PERMISSION_NAME.UNG_DUNG.SUA) ||
          hasPermissionUser(PERMISSION_NAME.UNG_DUNG.XOA)
        "
      >
        <template #body="slotProps">
          <div class="text-center">
            <font-awesome-icon
              icon="edit"
              v-if="hasPermissionUser(PERMISSION_NAME.UNG_DUNG.SUA)"
              v-b-popover.hover.top="'Cập nhật ứng dụng'"
              class="cursor-pointer color-red"
              @click="openEdit(slotProps.data)"
            />
            <font-awesome-icon
              icon="trash-alt"
              v-b-popover.hover.top="'Xóa ứng dụng'"
              v-if="hasPermissionUser(PERMISSION_NAME.UNG_DUNG.XOA)"
              class="cursor-pointer color-red ml-2"
              @click="openDelete(slotProps.data)"
            />
          </div>
        </template>
      </Column>
    </DataTable>
    <BasePagination
      class="mt-3"
      :current-page="requestInformation.pageIndex"
      :total-pages="totalPages"
      :total-rows="totalRows"
      @changeNum="onChangeNum($event)"
      @changePages="onChangePages($event)"
    />
    <ModalCapNhatApp
      ref="modalCapNhatApp"
      :is-edit.sync="isEdit"
      :data="appDaChon"
      @hidden="isEdit = false"
      @refresh="layDanhSachApp"
    />
    <ModalConfirm :title="appDaChon.name" @confirmed="xoaApp" />
  </div>
</template>

<script>
import BasePagination from "@/components/common/BasePagination";
import ModalCapNhatApp from "./ModalCapNhatApp";
import ModalConfirm from "@/components/modal/ModalConfirm";
import {
  NO_RESULTS_TEXT,
  BANG_DM_APP,
  PERMISSION_NAME,
} from "@/constants/constants";
import { CAP_NHAT_ACTIVE_APP } from "@/constants/message";
import { mapGetters } from "vuex";
import _isNil from "lodash/isNil";
import _isEmpty from "lodash/isEmpty";
import _cloneDeep from "lodash/cloneDeep";
import { hasPermissionUser } from "@/utils/permissionUtils";
const defaultSearchForm = {
  Code: "",
  Name: "",
  Description: "",
  URL: "",
};
export default {
  name: "DanhSachApp",
  components: {
    ModalConfirm,
    ModalCapNhatApp,
    BasePagination,
  },
  data() {
    return {
      PERMISSION_NAME,
      requestForm: _cloneDeep(defaultSearchForm),
      NO_RESULTS_TEXT: NO_RESULTS_TEXT,
      requestInformation: {
        filterBy: "",
        pageSize: 10,
        pageIndex: 1,
      },
      appDaChon: {},
      isEdit: false,
      openModalDelete: false,
      items: [],
      totalPages: 0,
      totalRows: 0,
      isLoadingTable: true,
      emptyHeaderTable: [
        BANG_DM_APP.stt,
        BANG_DM_APP.name,
        BANG_DM_APP.code,
        BANG_DM_APP.description,
        BANG_DM_APP.url,
        BANG_DM_APP.isActive,
        BANG_DM_APP.thaoTac,
      ],
      fieldNames: [
        {
          key: "stt",
          label: "STT",
        },
        {
          key: "code",
          label: "Mã ứng dụng",
        },
        {
          key: "name",
          label: "Tên ứng dụng",
        },
        {
          key: "description",
          label: "Mô tả",
        },
        {
          key: "url",
          label: "URL",
        },
        {
          key: "isActive",
          label: "Trạng thái",
        },
        {
          key: "thaoTac",
          label: "Thao tác",
        },
      ],
    };
  },
  created() {
    this.layDanhSachApp();
  },
  computed: {
    ...mapGetters({
      danhSachApp: "app/danhSachAppPaging",
    }),
    hasPageData() {
      return !_isEmpty(this.danhSachApp.items);
    },
    danhSachAppNoiBo() {
      return this.layDanhSachAppNoiBo(this.danhSachApp);
    },
  },
  watch: {
    danhSachApp: {
      handler() {
        this.totalPages = this.danhSachApp.totalPage;
        this.totalRows = _isNil(this.danhSachApp.totalCount)
          ? 0
          : this.danhSachApp.totalCount;
        this.items = this.danhSachApp.items;
      },
    },
  },
  methods: {
    hasPermissionUser,
    layDanhSachApp() {
      this.isLoadingTable = true;
      this.$store
        .dispatch("app/layDanhSachAppPaging", {
          ...this.requestInformation,
          ...this.requestForm,
        })
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    onChangeNum(pageSize) {
      this.requestInformation.pageIndex = 1;
      this.requestInformation.pageSize = pageSize;
      this.layDanhSachApp();
    },
    onChangePages(page) {
      this.requestInformation.pageIndex = page;
      this.layDanhSachApp();
    },
    openCreate() {
      this.appDaChon = {};
      this.isEdit = false;
      this.$refs["modalCapNhatApp"].$refs.modalCapNhatApp.show();
    },
    openEdit(item) {
      this.appDaChon = item;
      this.isEdit = true;
      this.$refs["modalCapNhatApp"].$refs.modalCapNhatApp.show();
    },
    openDelete(item) {
      this.appDaChon = item;
      this.$bvModal.show("modal-confirm");
    },
    xoaApp(confirm) {
      if (confirm) {
        console.log(this.appDaChon.id);
        this.$store.dispatch("app/xoaApp", {
          data: { id: this.appDaChon.id },
          onSuccess: this.layDanhSachApp,
        });
        this.$bvModal.hide("modal-confirm");
      }
    },
    capNhatThuTu() {
      let listUpdate = [];
      this.items.forEach(function (item, index) {
        listUpdate.push({ Id: item.id, ThuTu: index + 1 });
      });
      let payload = new FormData();
      payload.append("arrangeRequest", JSON.stringify(listUpdate));
      this.$store.dispatch("app/capNhatThuTu", {
        data: payload,
        onSuccess: this.layDanhSachApp,
      });
    },
    handleChangeTrangThai(item) {
      const payload = {
        ids: [item.id],
        isActivate: !item.isActive,
      };
      this.$store.dispatch("app/capNhatActiveApp", payload).then((res) => {
        if (res.data.succeeded) {
          this.$toasted.clear();
          this.$toasted.global.showSuccessMessage({
            message: CAP_NHAT_ACTIVE_APP,
          });
        }
      });
    },
    layDanhSachAppNoiBo(danhSachApp) {
      if (_isEmpty(danhSachApp.items)) {
        return [];
      }
      return danhSachApp.items.map((item, index) => {
        return {
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          name: item.name,
          code: item.code,
          id: item.id,
          thaoTac: "thaoTac",
        };
      });
    },
  },
};
</script>
